/* eslint-disable no-console */
import { httpModule } from '@shared/http';
import { Contract } from '@services/contract';
import { Propietor } from '@services/propietor';
import { Address } from '@/assets/entities';


export type PropertyFilters = {
    address: string;
    types: string[];
    state: number;
    cities: number[];
    propietors: number[];
};

export type Property = {
    id: number;
    externalReference: string;
    type: string;
    image: string;
    notes: string;
    observations: string;
    operation: string;
    price: number;
    entranceDate: string;
    terminationDate: string;
    contracts: Contract[];
    contractTaxService: any[];
    claims: any[];
    propietors: Propietor[];
    address: Address;
    organization: any;
}

export async function fetchProperties(page?: number, limit?: number, propietorId?: number, search?: string) {
    try {
        return await httpModule.get('/properties', {
            params: {
                page,
                limit,
                search,
                'propietor-id': propietorId
            }
        });
    } catch (ex) {
        console.warn('Error fetching properties');
        console.log(ex.response);
    }
}

export async function postProperty(property: object) {
    try {
        return await httpModule.post('/properties', property);
    } catch (ex) {
        console.warn('Error posting a property');
        console.log(ex.response);
    }
}

export async function postChangeProperty(dto: {property: number, propietor: number}) {
    try {
        return await httpModule.post('/properties/change-propietor', dto);
    } catch (ex) {
        console.warn('Error changing a propietor for a property');
        console.log(ex.response);
    }
}

export async function patchProperty(property: object) {
    try {
        return await httpModule.patch('/properties', property);
    } catch (ex) {
        console.warn('Error patching a property');
        console.log(ex.response);
    }
}

export async function getPropertyByID(id: number) {
    try {
        return await httpModule.get(`/properties/${id}`);
    } catch (ex) {
        console.warn('Error getting a property');
        console.log(ex.response);
    }
}

export async function deleteProperty(id: number) {
    try {
        return await httpModule.delete(`/properties/${id}`);
    } catch (ex) {
        console.warn('Error deleting a property');
        console.log(ex.response);
    }
}
